import { ReactNode } from "react";
import { atom } from "recoil";

export interface IModal {
  id: string;
  modalchildren: ReactNode;
  visible?: boolean;
  // isSlide?: boolean;
  edge?: "center" | "bottom";
  backdropRemove?: boolean;
}

export const modalState = atom<IModal[]>({
  key: "modalState",
  // effects_UNSTABLE: [
  // ({ onSet }) => onSet((newModals) => console.log("modals_log", newModals)),
  // ],
  default: [],
});
